import { Crypto, Effect, Encoding, Predicate } from 'effect';

export const randomUUID = Effect.flatMap(
  Crypto.Crypto,
  (crypto) => crypto.randomUUIDv4,
).pipe(Effect.orDie);

export const sha256 = (data: string | Uint8Array) =>
  Effect.flatMap(Crypto.Crypto, (crypto) =>
    crypto.digest(
      'SHA-256',
      Predicate.isString(data) ? new TextEncoder().encode(data) : data,
    ),
  ).pipe(Effect.orDie);

export const sha256Hex = (data: string | Uint8Array) =>
  sha256(data).pipe(Effect.map(Encoding.encodeHex));
